import React from 'react';
import { SetIcon } from 'components/SetIcon';
import { PublicSetInfo } from 'store/services/sets/publicSetsApi';

interface SetHeroProps {
  set: PublicSetInfo;
  totalCards: number;
}

const formatDate = (dateStr: string | null): string => {
  if (!dateStr) return 'Unknown';
  try {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  } catch {
    return 'Unknown';
  }
};

const formatSetType = (type: string | null): string => {
  if (!type) return '';
  return type.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
};

export const SetHero: React.FC<SetHeroProps> = ({ set, totalCards }) => {
  return (
    <header className="set-detail-hero">
      <div className="set-detail-icon-container">
        <SetIcon
          setIconUrl={set.iconUrl}
          setName={set.name}
          size="lg"
          inverted={true}
        />
      </div>
      <div className="set-detail-info">
        <h1 className="set-detail-name">{set.name}</h1>
        <div className="set-detail-meta">
          <span className="set-detail-code">{set.code.toUpperCase()}</span>
          <span className="set-detail-separator">|</span>
          <span className="set-detail-date">{formatDate(set.releasedAt)}</span>
          <span className="set-detail-separator">|</span>
          <span className="set-detail-count">
            {totalCards.toLocaleString()} cards
          </span>
          {set.setType && (
            <>
              <span className="set-detail-separator">|</span>
              <span className="set-detail-type">{formatSetType(set.setType)}</span>
            </>
          )}
        </div>
      </div>
    </header>
  );
};
